export const getTokenCustomerPortalByWindowLocation = () => {
  const { search } = window.location;

  if (search && search.includes("?token=")) {
    return search.replace("?token=", "");
  }
};
